import Counters from './Counters';
import DossierStack from './DossierStack';
import PlanningTask from './PlanningTask';
import Presence from './Presence';
import Task from './Task';

export default class TaskContainer {
  counters = Counters.EMPTY;
  presences: Array<Presence> = [];
  tasks: Array<Task> = [];
  planningTasks: Array<PlanningTask> = [];
  stacks: Array<DossierStack> = [];
}
